// Header du shell mobile Life — DA V3 validée (logo dégradé, icônes
// vectorielles recherche + notifications, salutation).
// Réf. : DEV/mockup_mobile_navigation_v3.html
import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
// Vrai logo Life (le même que l'écran de login)
import lifelogo from 'Components/images/logo.png'

const SearchIcon = () => (
  <svg viewBox="0 0 24 24">
    <circle cx="11" cy="11" r="7" />
    <path d="M20 20l-3.5-3.5" />
  </svg>
)

const BellIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.7 21a2 2 0 01-3.4 0" />
  </svg>
)

const MobileHeader = ({ user, hasUnread }) => {
  const { t, i18n } = useTranslation(['layout', 'common'])
  const navigate = useNavigate()
  const location = useLocation()
  const [searchOpen, setSearchOpen] = React.useState(false)
  const [query, setQuery] = React.useState('')

  // La salutation n'apparaît que sur la home « Aujourd'hui » — sur les
  // autres écrans le header reste compact (logo + actions).
  const isHome = location.pathname === '/'

  // Recherche fermée quand on quitte une page de résultats (même logique
  // que la NavBar desktop).
  React.useEffect(() => {
    if (!location.pathname.toLowerCase().startsWith('/search/')) {
      setQuery('')
      setSearchOpen(false)
    }
  }, [location])

  const submitSearch = () => {
    const q = query.trim()
    if (q) navigate(`/search/0/${q}`)
  }

  const today = new Date().toLocaleDateString(i18n.language || 'fr', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  })
  const firstName = user?.first_name || user?.username || ''

  return (
    <header className="lm-header">
      <div className="lm-hrow">
        <img
          src={lifelogo}
          alt="Life"
          className="lm-logo-img"
          onClick={() => navigate('/')}
        />
        <div className="lm-spacer" />
        <div
          className="lm-hic"
          role="button"
          aria-label={t('navbar.search', 'Rechercher')}
          onClick={() => setSearchOpen((v) => !v)}
        >
          <SearchIcon />
        </div>
        <div
          className="lm-hic"
          role="button"
          aria-label={t('navbar.notifications', 'Notifications')}
          onClick={() => navigate('/inbox')}
        >
          <BellIcon />
          {hasUnread && <span className="lm-dot" />}
        </div>
      </div>

      {searchOpen && (
        <div className="lm-search-row">
          <SearchIcon />
          <input
            autoFocus
            value={query}
            placeholder={t('navbar.searchPlaceholder', 'Rechercher partout dans Life…')}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && submitSearch()}
          />
        </div>
      )}

      {isHome && !searchOpen && (
        <div className="lm-hello">
          {today.charAt(0).toUpperCase() + today.slice(1)}
          <b>
            {t('navbar.hello', 'Bonjour')}
            {firstName ? ` ${firstName}` : ''} 👋
          </b>
        </div>
      )}
    </header>
  )
}

export default MobileHeader
